export default __webpack_public_path__ + "static/media/photo_5282747746622312925_y.64232af2.jpg";